import React from 'react';
import '../App.css';
import {
    Link
  } from "react-router-dom";

var title = { textAlign:'center', fontSize: "3em", marginTop: 60, color:'silver', fontWeight:"200" }
var subTitle = { textAlign:'center', fontSize: "2.3em", marginTop: -50, color:'white', fontWeight:"200" }
var subText = { textAlign:'center', fontSize: "1.5em", marginTop: 15, color:'white', fontWeight:"200" }

var windowSize = {
    display:"flex", flexDirection:'column',
    backgroundColor:'black',
    width: "100vw", minHeight: "100vh", color: 'white', justifyContent: "center", alignItems:'center', paddingTop:20,
}

class Index extends React.Component {
    constructor(props) {
        super(props);    
        this.state = {}
    }

render(){
    return(
        <div style={windowSize}>
            <br />
            <br />
            <br />
            <h1 style={title}><span style={{color: "rgb(11, 232, 129)" }}>R</span>eact <span style={{color: "rgb(11, 232, 129)" }}>S</span>tudio <span style={{
                color: "rgb(11, 232, 129)" 
                }}>C</span>ode</h1>
            <br/>
            <p style={subTitle}>Design tools for React web designers</p>
            <br/>
            <p style={subTitle}><span style={{color:'orange'}}>WARNING: old project based on React Classes</span></p>

            <p style={subText}>Simply choose a component and customize it with live rendering
            <br />
            Sizes, colors, shadows, borders, rotations and many other customization parameters 
            </p>
            <img style={{ width:"auto", height:280, marginTop:30, 
            marginBottom:-60, borderRadius:5, marginLeft:15,
            }} src='../visual.png' alt="creazerty" />
 
            <div style={{ margin: 50 }}></div>

            <Link className="boutonStudio" to="/studio">Enter the Studio</Link>

            <div style={{ marginTop: 30 }}>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_donations" />
            <input type="hidden" name="business" value="9QKPMCTQD324N" />
            <input type="hidden" name="item_name" value="Pay me a coffee" />
            <input type="hidden" name="currency_code" value="EUR" />
            <input type="image" src="cupcake.png" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" width="200" />
            <img alt="" border="0" src="https://www.paypal.com/en_FR/i/scr/pixel.gif" width="1" height="1" />
            </form>
            </div>

            <div style={{display:'flex', flexDirection:'row'}}>
            <a href="https://twitter.com/creazerty" target='blank'><img style={{ width:30, height:30, marginTop:50, marginBottom:-60, borderRadius:5, marginLeft:15 }} src='../twitter.png' alt="creazerty Twitter" /></a>
            </div>


            <p className='sign'>developed by Creazerty - <Link className='cgu' to="/cgu">before continue read the General terms and conditions of use</Link>
</p>
        </div>
    )
}

}

export default Index;